// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/homepage/homepage-learning-bro.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepageMainSection{
  background-color: #14293A;
  min-height: 60vh;
  color: #fff
}

.homepageImage{
  min-height: 55vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  overflow: visible;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.homePageMainContent{
  padding-top: 15vh;
}

.homepageCardIcon{
  background-color: #14293A;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/homepage/homepage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,yDAAqE;EACrE,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".homepageMainSection{\n  background-color: #14293A;\n  min-height: 60vh;\n  color: #fff\n}\n\n.homepageImage{\n  min-height: 55vh;\n  background-image: url(\"../../img/homepage/homepage-learning-bro.png\");\n  overflow: visible;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n}\n\n.homePageMainContent{\n  padding-top: 15vh;\n}\n\n.homepageCardIcon{\n  background-color: #14293A;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
